import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import WorkspaceCheckList from '../SuperAdminMgmtApp/WorkspaceCheckList';
import { Plus, PersonPlus, X  } from 'react-bootstrap-icons';
import utils from '../../utils';
import LBSelect from '../DesignSystem/LBSelect/LBSelect';
import { ToggleOn, ToggleOff } from 'react-bootstrap-icons'
import ToastDynamic from '../Layout/ToastDynamic/ToastDynamic';
import AddNewUser from './AddNewUser';

const INVITE_USER_SESSION_CACHE_PREFIX = 'inviteUserGlobalUsers';



function InviteUser({ tenID, workspaceName, appList, wkspcUsersList, superAdmin=false, wrkspcMasterList=null, refreshUserList, className='', wrkspcList=[] }) {
    //this component pops up the invite user modal and sends the request

    let [ userToSubmit, setUserToSubmit ] = useState({});
    let [ wkspcsToAddTo, setWkspcsToAddTo ] = useState([]);
    let [ multWkspcAddingMsg, setMultWkspcAddingMsg ] = useState();
    let [ formErrors, setFormErrors ] = useState({});
    let [ sendToServer, setSendToServer ] = useState(false);
    let [ sent, setSent ] = useState(false);
    let [ show, setShow ] = useState(false);
    let [ sending, setSending ] = useState(false);
    let [ selectedUsers, setSelectedUsers ] = useState([]);
    let [ selectedApps, setSelectedApps ] = useState([]);
    let [ selectedSecLevel, setSelectedSecLevel ] = useState(null);
    let [ submitStatus, setSubmitStatus ] = useState(null); // 'success', 'error', or null
    let [ userList, setUserList ] = useState([]);

    const { getAccessTokenSilently, user } = useAuth0();

    const half = Math.ceil(appList.length / 2);
    const firstHalf = appList.slice(0, half);
    const secondHalf = appList.slice(half);

    const getUserListCacheKey = () => `${INVITE_USER_SESSION_CACHE_PREFIX}:${tenID}`;

    const getCachedUserList = () => {
        if (!tenID) return null;

        try {
            const cachedValue = sessionStorage.getItem(getUserListCacheKey());
            if (!cachedValue) return null;

            const parsed = JSON.parse(cachedValue);
            return Array.isArray(parsed) ? parsed : null;
        } catch (error) {
            return null;
        }
    };

    const setCachedUserList = (users) => {
        if (!tenID) return;

        try {
            sessionStorage.setItem(getUserListCacheKey(), JSON.stringify(users));
        } catch (error) {
            // Ignore cache write failures and continue with in-memory state.
        }
    };

    const handleToggleApp = (app) => {
        let updatedAppList = [...selectedApps];
        if (updatedAppList.includes(app)) {
            updatedAppList = updatedAppList.filter(item => item !== app);
        } else {
            updatedAppList.push(app);
        }
        setSelectedApps(updatedAppList);
    };

    const getWkspcUsers = async (forceRefresh = false) => {
        // setLoadingUsers(true);
        // setUsersList([]);

        if (!tenID) {
            setUserList([]);
            return;
        }

        if (!forceRefresh) {
            const cachedUsers = getCachedUserList();
            if (cachedUsers && cachedUsers.length > 0) {
                setUserList(cachedUsers);
                return;
            }
        }

        let theAccToken = await utils.getAccessToken(getAccessTokenSilently, user);

        try {
            let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/membership/${tenID}/global`, {
                headers: {
                "Authorization": "Bearer " + theAccToken.accessToken
                }
            });

            // if(reloadWkspUser !== true) {
            //     utils.trackAppView('settings', tenID, theAccToken.accessToken);
            // }

            let users = await response.json();
            if (response.ok) {
                // Transform API response to expected format
                const transformedUsers = users.map(user => ({
                    ...user,
                    id: user.user_id || user.id,
                    displayName: user.name || user.displayName || user.email,
                    email: user.email || user.mail,
                    mail: user.email || user.mail  // Table expects 'mail' field for email display
                }));
                
                //sort users by name in alphabetical order
                const sortedUsers = transformedUsers.sort((a, b)=> utils.createStrSortOrder(a.displayName, b.displayName))
                setUserList(sortedUsers);
                setCachedUserList(sortedUsers);
            } else {
                console.error('Failed to fetch workspace users:', users);}
        } catch (error) {
            setUserList([]);
        }
        // setLoadingUsers(false);
    };

    // secLevel options
    const secLevelOptions = Array.from({ length: 6 }, (_, i) => i + 1);


    const validateEmail = (emailAddress) => {
        const emailFormatRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailFormatRegex.test(emailAddress)
    }

    const isNewUser = (emailAddress) => {
        let checkExist = userList.filter( (thisUser) => {
            return thisUser.mail.toLowerCase().indexOf(emailAddress.toLowerCase()) > -1
        });

        return checkExist.length < 1;
    }

    const handleWorkspaceForInvite = (e) => {
        let cpyWrkspaces = [...wkspcsToAddTo];
        let idOfWrkspace = e.target.id;
        let checked = e.target.checked;

        if(checked === true) {
            cpyWrkspaces.push(idOfWrkspace);
        } else {
            let idxOfthisWrkspace = cpyWrkspaces.indexOf(idOfWrkspace);

            if(idxOfthisWrkspace > -1) {
                cpyWrkspaces.splice(idxOfthisWrkspace, 1);
            }
        }

        setWkspcsToAddTo(cpyWrkspaces);
    }

    const validateForm = (formObj) => {
        //if invalid or missing, set formErrors and return false
        //else return true
        let newFormErrors = {};
        

        if(!formObj.hasOwnProperty('firstName') || formObj.firstName === '') {
            newFormErrors.firstName = "* Please add first name";
        }

        if(!formObj.hasOwnProperty('lastName') || formObj.lastName === '') {
            newFormErrors.lastName = "* Please add last name";
        }

        if(!formObj.hasOwnProperty('emailAddress') || formObj.emailAddress === '') {
            newFormErrors.emailAddress = "* Please add email";

        }

        //additionally, check that another user with this email does not already exist
        if(formObj.hasOwnProperty('emailAddress')) {


            if(validateEmail(formObj.emailAddress) === false) {
                newFormErrors.emailAddress = "* Please enter a valid email address";
            }

            if(isNewUser(formObj.emailAddress) === false) {
                newFormErrors.emailAddress = "* A user with that email already exists in this group."
            }
        }

        // setFormErrors(newFormErrors);
        return newFormErrors;

    }

    const inviteUser = async (usr) => {
        let errorsOnForm = validateForm(usr);

        if(Object.keys(errorsOnForm).length < 1) {
            let theAccToken = await utils.getAccessToken(getAccessTokenSilently, user);

            setSending(true);

            let res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/invite-user`,{
                method:'POST',
                headers: {
                    authorization: 'Bearer ' + theAccToken.accessToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: usr.emailAddress,
                    given_name: usr.firstName,
                    family_name: usr.lastName,
                    workspaces: [tenID]
                })
            });

            if(res.ok) {
                setSent(true);
                setFormErrors({});
            } else {
                setFormErrors({...formErrors, sendError: '* Something went wrong.  Please try again.'})
            }

            setSendToServer(false);
            setSending(false);
        } else {
            setFormErrors(errorsOnForm);
        }
    };

    const inviteAndAddToSelectedWorkspaces = async (usr, wrkspaces) => {
        let errorsOnForm = validateForm(usr);

        if(Object.keys(errorsOnForm).length < 1) {
            let theAccToken = await utils.getAccessToken(getAccessTokenSilently, user);
            setFormErrors({});
            setSending(true);

            const res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/invite-user`, {
                method: 'POST',
                headers: {
                    authorization: 'Bearer ' + theAccToken.accessToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: usr.emailAddress,
                    given_name: usr.firstName,
                    family_name: usr.lastName,
                    securityLevel: usr.securityLevel,
                    defaultWorkspace: usr.defaultWorkspace,
                    workspaces: wrkspaces
                })
            });

            if(!res.ok) {
                setFormErrors({...formErrors, sendError: '* Something went wrong.  Please try again.'});
            } else {
                setSent(true);
                setFormErrors({});
            }

            setSendToServer(false);
            setWkspcsToAddTo([]);
            setMultWkspcAddingMsg('');
            setSending(false);
        } else {
            setFormErrors(errorsOnForm);
        }
    }


    useEffect(() => {
        getWkspcUsers();
        if(sendToServer === true) {
            //send to invite
            if(superAdmin && superAdmin === true) {
                inviteAndAddToSelectedWorkspaces(userToSubmit, wkspcsToAddTo);
            } else {
                inviteUser(userToSubmit);
            } 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sendToServer]);

    const resetSpace = () => {
        setUserToSubmit({});
        setWkspcsToAddTo([]);
        setSendToServer(false);
        setFormErrors({});
        setSent(false);
        setSending(false);
        setSelectedUsers([]);
        setSelectedApps([]);
        setSelectedSecLevel(null);
        
        if(refreshUserList && typeof refreshUserList === 'function'){
            refreshUserList();
        }
        
    }

    const handleClose = () => { 
        setShow(false);
        resetSpace();
    };
    
    const handleClick = (which) => {
        switch(which.toLowerCase()) {
            case 'submit':
                setSendToServer(true);
                break;
            case 'close':
                handleClose();
                break;
            case 'another':
                resetSpace();
                break;
            default:
                break;
        }
    }

    const addUsersToWorkspaces = async () => {
        let theAccToken = await utils.getAccessToken(getAccessTokenSilently, user);
        
        let allSuccessful = true;
        let failedUsers = [];
        
        // Use Promise.all to wait for all user invitations to complete
        const promises = selectedUsers.map(async (usr) => {
            try {
                let res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${usr}/workspace-add?tenid=${tenID}`,{
                    method:'POST',
                    headers: {
                        authorization: 'Bearer ' + theAccToken.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        workspaceID: tenID,
                        appsList: selectedApps.join(','),
                        securityLevel: selectedSecLevel
                    })
                });
                
                if (!res.ok) {
                    console.error(`Failed to add user ${usr} to workspace ${workspaceName}`);
                    allSuccessful = false;
                    failedUsers.push(usr);
                    return false;
                }
                return true;
            } catch (error) {
                console.error(`Error adding user ${usr} to workspace ${workspaceName}:`, error);
                allSuccessful = false;
                failedUsers.push(usr);
                return false;
            }
        });
        
        // Wait for all invitations to complete
        await Promise.all(promises);
        
        // Update state based on overall results
        if (allSuccessful) {
            setSelectedApps([]);
            setSelectedSecLevel(null);
            setSelectedUsers([]);
            setSubmitStatus('success');
        } else {
            setSubmitStatus('error');
        }
    }

    return (
        <>
            <Button className={className} variant="primary" onClick={() => {setShow(true)}}><Plus className='m-i-start'/>Add User </Button>     
            
            <Modal className="invite-modal m-b-start-07" show={show} onHide={handleClose}>
                
                <Modal.Header className='display-flex align-items-center justify-between '>
                    <div className='display-flex align-items-center'>
                        <PersonPlus className='m-i-end-03' size={20}/>
                        <Modal.Title className='heading-h3'>Invite a user to this Workspace</Modal.Title>
                    </div>
                    
                    <X className='cursor-pointer' size={20} onClick={handleClose} />
                </Modal.Header>
                <Modal.Body className='p-b-start'>
                <Form>
                    <p className='label-medium'>Invite an existing Workspace user to this workspace: {workspaceName}</p>
                    <Form.Label className='label-medium'>Search for user(s)</Form.Label>
                    <LBSelect
                        className='p-b-end-06'
                        fieldName={'existingUserSearch'}
                        value={selectedUsers}
                        onChange={setSelectedUsers}
                        options={userList && userList.length > 0 ? userList.map( (usr) => ({ label: usr.displayName + ' -- ' + usr.email, value: usr.id , disabled: wkspcUsersList.some(wkspcUser => wkspcUser.id === usr.id)}) ) : [] }
                        searchable={true}
                        multiSelect={true}
                        clearable={true}
                        closeOnSelect={false}
                        maxSelectedDisplay={20}
                        loading={userList === null || userList.length < 1}
                    />

                    <Form.Label className='label-medium'>Select Security Level</Form.Label>
                    <LBSelect 
                        className='p-b-end-06'
                        fieldName={'secLevelSelect'}
                        value={selectedSecLevel}
                        onChange={setSelectedSecLevel}
                        options={secLevelOptions.map(level => ({ label: `Level ${level}`, value: level }))}
                    />


                    {selectedUsers.length > 0 && selectedSecLevel ? 
                        <>
                            <p className='label-medium'>Apps list</p>
                            <Row>
                                <Col>
                                    {
                                        firstHalf.map((app) => {
                                            const isActive = selectedApps.includes(app.fields.apptype)
                                            return (

                                            <Button
                                                className="text-primary-light border-none surface-transparent align-left display-block radio-btn-svg"
                                                onClick={() => {handleToggleApp(app.fields.apptype)}}
                                                aria-pressed={isActive}
                                                key={app.fields.apptype}
                                            >
                                            {
                                                isActive ? 
                                                    <ToggleOn className='m-i-end-04' /> 
                                                : <ToggleOff className='m-i-end-04' />
                                            }
                                                {app.fields.apptype}
                                            </Button>
                                            )
                                        })
                                    }
                                </Col>
                                <Col>
                                    {
                                        secondHalf.map((app) => {
                                            const isActive = selectedApps.includes(app.fields.apptype)
                                            return (

                                            <Button
                                                className="text-primary-light border-none surface-transparent align-left display-block radio-btn-svg"
                                                onClick={() => {handleToggleApp(app.fields.apptype)}}
                                                aria-pressed={isActive}
                                                key={app.fields.apptype}
                                            >
                                            {
                                                isActive ? 
                                                    <ToggleOn className='m-i-end-04' /> 
                                                : <ToggleOff className='m-i-end-04' />
                                            }
                                                {app.fields.apptype}
                                            </Button>
                                            )
                                        })
                                    }
                                </Col>
                            </Row>
                        </> : null
                    }
                    <Row>
                        <AddNewUser
                            tenID={tenID}
                            wrkspcList={wrkspcList}
                        />
                    </Row>
                    
                    {
                        superAdmin === true && wrkspcMasterList && wrkspcMasterList.length > 0 ?
                            <WorkspaceCheckList 
                                masterList={ wrkspcMasterList } 
                                changeHandler={ handleWorkspaceForInvite } 
                                wrkMessage={multWkspcAddingMsg} />
                        : null
                    }
                </Form>
                </Modal.Body>
                <Modal.Footer className="right-align">
                    <Button className='btn-sm-invisible' onClick={sent ? () => handleClick('another') : () => handleClick('close')}>
                        { sent ? 'Send Another Invite' : 'Cancel'}
                    </Button>
                    <Button className='btn-sm-solid' onClick={() => {
                            setSending(true);
                            Promise.resolve(addUsersToWorkspaces()).finally(() => setSending(false));
                        }} disabled={sending || selectedUsers.length < 1 || !selectedSecLevel || selectedApps.length < 1}>
                        {`Invite (${selectedUsers.length}) User(s)`}
                    </Button>
                    {submitStatus === 'success' ?
                        <ToastDynamic show={true} variant="success" content={`Successfully invited users to workspace ${workspaceName}.`} handleCloseToast={() => setSubmitStatus(null)} />
                    : submitStatus === 'error' && <ToastDynamic show={true} variant="error" content={`There was an error inviting users to workspace ${workspaceName}. Please try again.`} handleCloseToast={() => setSubmitStatus(null)} />}
                </Modal.Footer>
            </Modal>
                
            
        </>
    )
}

export default InviteUser
